import clsx from 'clsx';

import { ErrorMessage } from '../error-message/ErrorMessage';
import { GoogleFontIcon } from '../icons/GoogleFontIcon';

import styles from './form.module.scss';

export type FormErrorProps = {
  error?: string;
  inline?: boolean;
};

export function FormError({ error, inline }: FormErrorProps) {
  if (!error || error === '' || inline) {
    return undefined;
  }
  return (
    <ErrorMessage className={styles['error-message']}>{error}</ErrorMessage>
  );
}

export type SelectIconProps = {
  variant?: 'primary' | 'secondary';
  disabled?: boolean;
  error?: boolean;
};

export const SelectIcon = ({
  disabled,
  error,
  variant = 'secondary',
}: SelectIconProps) => (
  <div
    data-testid="toggle-drop-down"
    className={clsx(
      styles['select-icon'],
      variant === 'primary' && styles['select-icon--primary'],
      disabled && styles['select-icon--disabled'],
      error && styles['select-icon--error']
    )}
  >
    <GoogleFontIcon name="change_history" solid />
  </div>
);
